/* eslint-disable import/prefer-default-export */

import { SEG_LIST } from 'src/store/ActionTypes';

export const setGridState = (state) => ({
  type: SEG_LIST.SET_GRID_STATE,
  payload: state,
});

export const setSelectedGridRows = (rows) => ({
  type: SEG_LIST.SET_SELECTED_GRID_ROWS,
  payload: rows,
});

export const fetchStories = (query) => ({
  type: SEG_LIST.FETCH_STORIES,
  payload: query,
});

export const fetchSegments = (query) => ({
  type: SEG_LIST.FETCH_SEGMENTS,
  payload: query,
});

export const selectGridRow = (row) => ({
  type: SEG_LIST.SELECT_GRID_ROW,
  payload: row,
});

export const deselectGridRow = (row) => ({
  type: SEG_LIST.DESELECT_GRID_ROW,
  payload: row,
});

export const editSegment = (id, payload) => ({
  type: SEG_LIST.EDIT_SEGMENT,
  payload: {
    id,
    payload,
  },
});

export const editCluster = (parentId, id, payload) => ({
  type: SEG_LIST.EDIT_CLUSTER,
  payload: {
    id,
    parentId,
    payload,
  },
});

export const editDataset = (id, payload) => ({
  type: SEG_LIST.EDIT_DATASET,
  payload: {
    id,
    payload,
  },
});

export const createModel = (payload) => ({
  type: SEG_LIST.CREATE_MODEL,
  payload,
});

export const fetchModels = (query) => ({
  type: SEG_LIST.FETCH_MODELS,
  payload: query,
});

export const addModelTarget = (id, payload) => ({
  type: SEG_LIST.ADD_MODEL_TARGET,
  payload: { id, payload },
});

export const checkDeleteSegment = (id) => ({
  type: SEG_LIST.CHECK_DELETE_SEGMENT,
  payload: id,
});

export const deleteSegment = (id) => ({
  type: SEG_LIST.DELETE_SEGMENT,
  payload: id,
});

export const deleteCluster = (parentId, id) => ({
  type: SEG_LIST.DELETE_CLUSTER,
  payload: { parentId, id },
});

export const deselectAllSegmentIds = () => ({
  type: SEG_LIST.DESELECT_ALL_SEGMENT_IDS,
});

export const fetchDownloadUrl = (entityId, entity, id) => ({
  type: SEG_LIST.FETCH_DOWNLOAD_URL,
  payload: { entityId, entity, id },
});

export const deleteDownload = (entityId, entity, id) => ({
  type: SEG_LIST.DELETE_DOWNLOAD,
  payload: { entityId, entity, id },
});

export const fetchClientByTenant = (tenant) => ({
  type: SEG_LIST.FETCH_CLIENT_BY_TENANT,
  payload: tenant,
});

/**
 * unset - Reset a redux state key to its default
 * @param key {string} the state key to reset
 * @returns {{payload: string, type: string}}
 */
export const unset = (key) => ({
  type: SEG_LIST.UNSET,
  payload: key,
});
